import { Settings } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entry only — imported by the eager shell bundle; keep free of pages/api (H-10).
 * The hub fans out to company profile, users, policies, numbering, and the
 * other settings surfaces — those don't get their own sidebar entries. */
export const settingsNav: NavEntry = {
  label: 'Settings',
  icon: Settings,
  path: '/settings',
  permission: 'settings:read',
  order: 900,
}
